import { render, staticRenderFns } from "./LayoutFrame.vue?vue&type=template&id=7f8fc214&"
import script from "./LayoutFrame.vue?vue&type=script&lang=js&"
export * from "./LayoutFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports